import emitter from '../utils/emitter'

import { YOUTUBE_API } from '../index'

/** exemple html **/
/* <div class="youtube-player" js-youtube-player>
    <div class="youtube-player__cover" js-youtube-player-cover>
        <img class="w-full" src="https://img.youtube.com/vi/aqz-KE-bpKQ/hqdefault.jpg" alt="" />
        <button js-youtube-player-play class="youtube-player__play">
            <span class="sr-only">Play video</span>
        </button>
    </div>
    <div class="youtube-player__iframe" js-youtube-player-iframe data-video="aqz-KE-bpKQ"></div>
  </div> */

export default {
  name: 'youtube-player',
  player: null,

  ui: {
    play: '[js-youtube-player-play]',
    video: '[js-youtube-player-iframe]',
    cover: '[js-youtube-player-cover]',
  },

  events: [
    {
      target: 'play',
      on: 'click',
      handle () {
        this.ui.cover.classList.add('is-hidden')
        this.player.playVideo()
      },
    },
  ],

  componentDidMount () {
    /* eslint-disable */
    if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
      this.handleYoutubeAPIReady()
    } else {
      emitter.on(YOUTUBE_API.IS_READY, this.handleYoutubeAPIReady)
    }
    /* eslint-enable */
  },

  handleYoutubeAPIReady () {
    /* eslint-disable */
    this.player = new YT.Player(this.ui.video, {
      height: '390',
      width: '640',
      videoId: this.ui.video.dataset.video,
    })
    /* eslint-enable */
  },
}
